<template>
  <Wysiwyg
    v-if="resource.columns.markdownText"
    class="intro"
  >
    <div v-editable="resource.columns.markdownText" />
  </Wysiwyg>
</template>

<script>
import editable from '@i22/frontend-cms-utils/mixins/editable'
import checkViewport from 'beisheim/mixins/check-viewport'
import Wysiwyg from 'beisheim/components/elements/wysiwyg'

export default {
  components: {
    Wysiwyg
  },
  mixins: [ checkViewport, editable ],
  watch: {
    elBoundingRect () {
      if (this.scrolledBehind) {
        this.$el.style.opacity = 1
        this.$el.style.transform = 'translateY(0px)'
      } else {
        this.$el.style.opacity = 0
        this.$el.style.transform = 'translateY(50px)'
      }
    }
  }
}
</script>

<style lang="scss">
  @import 'beisheim/scss/grid';
  @import 'beisheim/scss/font';
  @import 'beisheim/scss/scale';
  @import 'beisheim/scss/breakpoints';

  .intro {
    @include font(1);
    @include grid-spacing(padding-left, 2);
    @include grid-spacing(padding-right, 2);
    transform: translateY(50px);
    opacity: 0;
    transition: transform 800ms cubic-bezier(.17,.67,.29,1), opacity 400ms ease-out;
    max-width: $max-width;
    margin: scale(8) auto;

    @include from(3) {
      @include font(2);
      @include grid-spacing(padding-left, 3);
      @include grid-spacing(padding-right, 3);
      margin: scale(26) auto;
    }

    p {
      @include font(1);
      line-height: 1.2;
      margin-bottom: scale(4);

      @include from(3) {
        @include font(2);
        margin-bottom: scale(8);
      }

      &:last-child {
        margin: 0;
      }
    }
  }
</style>
